import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { WalletSummaryModel } from '../models/walletSummaryModel';

@Injectable({
    providedIn: 'root'
  })
  export class TierService extends BaseService {
    apiUrl = '/api/wallet/';
    constructor(private httpClient: HttpClient) {
      super();
    }
  getWalletSammary() {
        return this.httpClient.get<WalletSummaryModel>(
          this.baseUrl + this.apiUrl + 'GetWalletSummary',
          this.getAuthHeader()

        );
      }
      
}